export default __webpack_public_path__ + "static/media/default.802f87ac.jpg";